/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/

import { getAccountEndpoint } from '@src/oms/InvoicesView/utils/InvoicesOperationUtils';
import { useCallback, useState } from 'react';
import { request } from '@broadleaf/admin-components/dist/metadata/utils/request';
import { IAccount } from '@src/oms/utils/RmCustomerUtils';

type Response = {
  fetchAccount: (accountId: string, contextParams: any) => Promise<IAccount>;
  isLoading: boolean;
};

export default function useFetchAccount(): Response {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchAccount = useCallback(
    async (accountId, contextParams) => {
      if (isLoading) {
        return;
      }

      setIsLoading(true);
      try {
        const endpoint = getAccountEndpoint(accountId);
        const { data } = await request({ ...endpoint }, contextParams);
        return data;
      } finally {
        setIsLoading(false);
      }
    },
    [isLoading]
  );

  return { fetchAccount, isLoading };
}
